import { Injectable, inject } from '@angular/core';
import { ConfigurationService } from '../shared/services/configuration.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SupplierPaymentModel } from '../models/supplier-payment.model';

@Injectable({
  providedIn: 'root',
})
export class SupplierPaymentService {
  private readonly http = inject(HttpClient);
  private readonly configSvc = inject(ConfigurationService);

  private backUrl;

  constructor() {
    this.backUrl = `${this.configSvc.workloadsApiUrl}api`;
  }

  getAllPayments(
    isProjection: boolean,
    initDate?: string,
    finalDate?: string
  ): Observable<Array<SupplierPaymentModel>> {
    if (initDate != undefined && finalDate != undefined) {
      const params = new HttpParams()
        .set('isProjection', isProjection)
        .set('fromDate', initDate)
        .set('toDate', finalDate);
      return this.http.get<Array<SupplierPaymentModel>>(`${this.backUrl}/contractors/contractorPayments?${params}`);
    } else {
      const params = new HttpParams().set('isProjection', isProjection);
      return this.http.get<Array<SupplierPaymentModel>>(`${this.backUrl}/contractors/contractorPayments?${params}`);
    }
  }

  updateObservation(id: string, observation: string) {
    return this.http.patch(`${this.backUrl}/contractors/contractorPayments/${id}/observation`, {
      observation: observation,
    });
  }
}
